/**
 * Created by vladislav on 17.09.2020
 */

const SimpleLocation = function (locationConfig, slot) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;

    this.locationConfig = locationConfig;
    this.locationId = locationConfig.locationId;

    this.stage = this.slot.load("stage") || 0;
    this.progress = this.slot.load("progress") || 0;

    this.logEvents();
};

SimpleLocation.prototype = Object.create(cleverapps.EventEmitter.prototype);
SimpleLocation.prototype.constructor = SimpleLocation;

SimpleLocation.prototype.setStage = function (stage) {
    this.stage = +stage || 0;
    this.slot.save("stage", this.stage);

    cleverapps.user.incProgressCompare();
};

SimpleLocation.prototype.logEvents = function () {
    if (this.isLocationCompleted()) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.PASS_ALL_LOCATIONS);
    }
};

SimpleLocation.prototype.getStage = function () {
    return Math.min(this.stage, this.getTotalStages() - 1);
};

SimpleLocation.prototype.getTotalStages = function () {
    if (this.totalStagesCache !== undefined) {
        return this.totalStagesCache;
    }

    this.totalStagesCache = SimpleLocation.getTotalStages();

    return this.totalStagesCache;
};

SimpleLocation.prototype.changeProgress = function (progress, silent) {
    this.setProgress(this.progress + progress, silent);
};

SimpleLocation.prototype.setProgress = function (progress, silent) {
    this.progress = +progress || 0;
    this.slot.save("progress", this.progress);

    cleverapps.user.incProgressCompare();

    if (!silent) {
        this.onUpdateProgress();
    }
};

SimpleLocation.prototype.onUpdateProgress = function () {
    cleverapps.focusManager.showControlsWhileFocused("progress_view");

    this.trigger("updateProgress");
};

SimpleLocation.prototype.getProgress = function () {
    return this.progress;
};

SimpleLocation.prototype.getRequiredProgress = function () {
    return SimpleLocation.GetRequiredProgress(this.stage);
};

SimpleLocation.prototype.isComingSoonStage = function (stage) {
    return stage >= this.getTotalStages();
};

SimpleLocation.prototype.isLastStage = function (stage) {
    return stage === this.getTotalStages() - 1;
};

SimpleLocation.prototype.isLocationCompleted = function () {
    return this.isComingSoonStage(this.stage) || this.isLastStage(this.stage) && this.isCompleted();
};

SimpleLocation.prototype.isAllContentDone = function () {
    return this.isLocationCompleted();
};

SimpleLocation.prototype.isCompleted = function () {
    return this.getProgress() >= this.getRequiredProgress();
};

SimpleLocation.prototype.gamePlayed = function (game) {
    if (game.outcome !== GameBase.OUTCOME_VICTORY) {
        return;
    }

    game.rewards.locationProgress = this.amountLevelStars(game.level);

    if (!cleverapps.isKnockoutGame() || cleverapps.knockoutGame.rumble.outcome === Rumble.OUTCOME_WIN) {
        cleverapps.user.incPhysicalLevel();
    }
};

SimpleLocation.prototype.amountLevelStars = function (level) {
    if (level.isHard()) {
        return 3;
    }

    if (level.isTricky()) {
        return 2;
    }

    return 1;
};

SimpleLocation.prototype.calcBundles = function () {
    return [
        this.getBackgroundBundle(),
        this.getIconBundle(this.getStage()),
        this.getIconBundle(this.getStage() + 1),
        this.getPostMoveActionBundle()
    ].filter(Boolean);
};

SimpleLocation.prototype.getIconBundle = function (stage) {
    if (stage >= this.getTotalStages() || cleverapps.config.rpg) {
        return "simple_background_icon_coming_soon";
    }

    return `simple_background_icon_${stage}`;
};

SimpleLocation.prototype.getBackgroundBundle = function () {
    if (cleverapps.config.rpg) {
        return;
    }

    const stage = this.getStage();

    return [
        `simple_background_${stage}`,
        (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? "simple_background_vertical_" : "simple_background_horizontal_") + stage,
        `simple_background_${cleverapps.config.orientation}_${stage}`
    ].find((bundleName) => bundles[bundleName]);
};

SimpleLocation.prototype.getPostMoveActionBundle = function () {
    if (cleverapps.config.type === "tile3") {
        if (TileGenerator.getNewSkins().length) {
            return "tiles_unlock_window";
        }
    }
};

SimpleLocation.prototype.isForceAvailable = function () {
    return cleverapps.user.currentPhysicalLevel.episode === 0 && !cleverapps.forces.isShown(Forces.SIMPLE) && cleverapps.config.type !== "match3";
};

SimpleLocation.prototype.showForce = function () {
    cleverapps.forces.saveForce(Forces.SIMPLE);
    this.trigger("showForce");
};

SimpleLocation.prototype.calcReward = function (splitToRewards, stage) {
    let rewards;
    if (stage < 1) {
        rewards = RewardsConfig.LocationSimple0;
    } else if (stage < 45) {
        rewards = RewardsConfig.LocationSimple1;
    } else {
        rewards = RewardsConfig.LocationSimple2;
    }

    if (!splitToRewards) {
        return rewards;
    }

    const list = [];
    for (const type in rewards) {
        const value = rewards[type];
        if (RewardTypes[type]) {
            if (RewardTypes[type].parse) {
                [].concat(RewardTypes[type].parse(value)).forEach((reward) => {
                    list.push({ type, value: reward.value });
                });
            } else {
                list.push({ type, value });
            }
        }
    }

    return list;
};

SimpleLocation.prototype.moveNextStage = function () {
    let forceShown = false;

    cleverapps.focusManager.display({
        focus: "moveNextStage",
        control: ["progress_view", "play_button", "score_mode_button"],
        actions: [
            (f) => {
                this.trigger("nextStage");
                cleverapps.effects.fire("simple.location.nextStage");

                cleverapps.timeouts.setTimeout(f, 1200);
            },

            (f) => {
                if (this.isForceAvailable()) {
                    this.showForce();
                    forceShown = true;
                    cleverapps.timeouts.setTimeout(f, 800);
                } else if (cleverapps.config.rpg) {
                    const scene = cleverapps.Scenes.GetSceneComponent(SimpleMainSceneComponent);
                    scene.completeCurrentPage(f);
                } else {
                    f();
                }
            },

            (f) => {
                this.setProgress(0);
                this.setStage(this.stage + 1);
                this.logEvents();

                cleverapps.focusManager.hideControlsWhileFocused("progress_view");

                f();
            },

            (f) => {
                if (this.isLocationCompleted()) {
                    cleverapps.Scenes.GetRunningScene().sceneComponent.removeFilmEffect(0.6, f);
                } else {
                    f();
                }
            },

            (f) => {
                if (this.isLocationCompleted()) {
                    if (cleverapps.newVersionChecker.hasNewVersion()) {
                        cleverapps.newVersionChecker.showUpgradeWindow(f, NewVersionChecker.TRIGGER_ALL_DONE);
                    } else {
                        new AllDoneWindow();
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                    return;
                }

                cleverapps.focusManager.compound(f, [
                    (f) => {
                        connector.social.markAchievement({});
                        cleverapps.metrics.logEvent(cleverapps.EVENTS.SIMPLE_METHA_LEVELUP);
                        f();
                    },
                    (f) => {
                        const bundles = this.calcBundles();
                        if (bundles) {
                            f = cleverapps.wait(2, f);
                            cleverapps.bundleLoader.loadBundles(bundles, { onSuccess: f });
                        }

                        if (cleverapps.config.rpg) {
                            cleverapps.Scenes.GetSceneComponent(SimpleMainSceneComponent).startNextPage(f);
                        } else {
                            new BackgroundsWindow({ moveNext: true, forceMinimal: forceShown });
                            cleverapps.focusManager.onceNoWindowsListener = f;
                        }
                    },
                    (f) => {
                        if (cleverapps.config.rpg) {
                            f();
                        } else {
                            cleverapps.Scenes.GetSceneComponent(SimpleMainSceneComponent).moveNextBg(f);
                        }
                    },
                    (f) => {
                        if (cleverapps.config.type !== "tile3" || !TileGenerator.getNewSkins().length) {
                            f();
                            return;
                        }

                        cleverapps.focusManager.compound(f, [
                            (f) => {
                                cleverapps.focusManager.hideAllControls();
                                cleverapps.aims.whenAllHidden(f);
                            },

                            (f) => {
                                new TilesUnlockWindow();
                                cleverapps.focusManager.onceNoWindowsListener = f;
                            },

                            (f) => {
                                cleverapps.focusManager.showControlsWhileFocused("progress_view");

                                f();
                            }
                        ]);
                    }
                ]);
            },

            (f) => {
                if (cleverapps.playButton && cleverapps.playButton.passedLevel && cleverapps.config.name !== "woodenblock") {
                    cleverapps.playButton.animatePassLevel();
                }
                f();
            }
        ]
    });
};

SimpleLocation.GetMainScene = function () {
    return bundles.main.jsons.simplemainscene_prefab_json;
};

SimpleLocation.getTotalStages = function () {
    for (let stage = 0; ; ++stage) {
        const available = cleverapps.config.rpg
            ? Boolean(bundles[`episode_${stage}`])
            : Boolean(
                bundles[`simple_background_${stage}`]
                || bundles[`simple_background_horizontal_${stage}`]
                || bundles[`simple_background_vertical_${stage}`]
            );

        if (!available) {
            return stage;
        }
    }
};

SimpleLocation.GetRequiredProgress = function (stage) {
    let stars = [
        5, 10, 20, 30, 30, 40, 40, 40, 40, 40,
        50, 50, 50, 50, 50, 70, 70, 70, 70, 70,
        100, 100, 100, 100, 100, 125, 125, 125, 125, 125,
        150, 150, 150, 150, 150, 175, 175, 175, 175, 175,
        200, 200, 200, 200, 200, 225, 225, 225, 225, 225
    ];

    if (cleverapps.config.rpg) {
        stars = [5, 10, 15, 20, 25];
    }

    if (stage < stars.length) {
        return stars[stage];
    }

    return stars[stars.length - 1];
};
